export const vahaMomentsProductS = {
    mainPromoHeadline:
      "products.product.promotions.vahaMoments.mainPromoHeadline",
    heading: {
      image: "products.productS.promotions.vahaMoments.heading.image",
      title: "products.productS.promotions.vahaMoments.heading.title",
    },
    pricesBeforeAfter: {
      priceBefore:
        "products.productS.promotions.vahaMoments.pricesBeforeAfter.priceBefore",
      priceAfter:
        "products.productS.promotions.vahaMoments.pricesBeforeAfter.priceAfter",
    },
    footer: "products.productS.promotions.vahaMoments.footer",
    total: {
      headline: "products.productS.promotions.vahaMoments.total.headline",
      priceBefore: "products.productS.promotions.vahaMoments.total.priceBefore",
      priceAfter: "products.productS.promotions.vahaMoments.total.priceAfter",
    },
    discount: {
      heading: "products.productS.promotions.vahaMoments.discount.heading",
      title: "products.productS.promotions.vahaMoments.discount.title",
      amount: "products.productS.promotions.vahaMoments.discount.amount",
      code: {
        description:
          "products.productS.promotions.vahaMoments.discount.code.description",
        promoCode:
          "products.productS.promotions.vahaMoments.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title: "products.productS.promotions.vahaMoments.items.item1.title",
        description:
          "products.productS.promotions.vahaMoments.items.item1.description",
        priceBefore:
          "products.productS.promotions.vahaMoments.items.item1.priceBefore",
        priceAfter:
          "products.productS.promotions.vahaMoments.items.item1.priceAfter",
      },
      item2: {
        title: "products.productS.promotions.vahaMoments.items.item2.title",
        description:
          "products.productS.promotions.vahaMoments.items.item2.description",
        priceBefore:
          "products.productS.promotions.vahaMoments.items.item2.priceBefore",
        priceAfter: "products.productS.promotions.vahaMoments.items.item2.priceAfter",
      },
      item3: {
        title: "products.productS.promotions.vahaMoments.items.item3.title",
        description:
          "products.productS.promotions.vahaMoments.items.item3.description",
        priceBefore:
          "products.productS.promotions.vahaMoments.items.item3.priceBefore",
        priceAfter:
          "products.productS.promotions.vahaMoments.items.item3.priceAfter",
      },
      item4: {
        title: "products.productS.promotions.vahaMoments.items.item4.title",
        description:
          "products.productS.promotions.vahaMoments.items.item4.description",
        priceBefore:
          "products.productS.promotions.vahaMoments.items.item4.priceBefore",
        priceAfter:
          "products.productS.promotions.vahaMoments.items.item4.priceAfter",
      },
      item5: {
        title: "products.productS.promotions.vahaMoments.items.item5.title",
        description:
          "products.productS.promotions.vahaMoments.items.item5.description",
        priceBefore:
          "products.productS.promotions.vahaMoments.items.item5.priceBefore",
        priceAfter:
          "products.productS.promotions.vahaMoments.items.item5.priceAfter",
      },
    },
  };
  
  export const flatrateVahaMomentsProductS = {
    mainPromoHeadline:
      "products.productS.promotions.flatrateVahaMoments.mainPromoHeadline",
    heading: {
      image: "products.productS.promotions.flatrateVahaMoments.heading.image",
      title: "products.productS.promotions.flatrateVahaMoments.heading.title",
    },
    footer: "products.productS.promotions.flatrateVahaMoments.footer",
    total: {
      headline:
        "products.productS.promotions.flatrateVahaMoments.total.headline",
      priceBefore:
        "products.productS.promotions.flatrateVahaMoments.total.priceBefore",
      priceAfter:
        "products.productS.promotions.flatrateVahaMoments.total.priceAfter",
    },
    discount: {
      heading: "products.productS.promotions.vahaMoments.discount.heading",
      title: "products.productS.promotions.flatrateVahaMoments.discount.title",
      amount: "products.productS.promotions.flatrateVahaMoments.discount.amount",
      code: {
        description:
          "products.productS.promotions.flatrateVahaMoments.discount.code.description",
        promoCode:
          "products.productS.promotions.flatrateVahaMoments.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title:
          "products.productS.promotions.flatrateVahaMoments.items.item1.title",
        description:
          "products.productS.promotions.flatrateVahaMoments.items.item1.description",
        priceBefore:
          "products.productS.promotions.flatrateVahaMoments.items.item1.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateVahaMoments.items.item1.priceAfter",
      },
      item2: {
        title:
          "products.productS.promotions.flatrateVahaMoments.items.item2.title",
        description:
          "products.productS.promotions.flatrateVahaMoments.items.item2.description",
        priceBefore:
          "products.productS.promotions.flatrateVahaMoments.items.item2.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateVahaMoments.items.item2.priceAfter",
      },
      item3: {
        title:
          "products.productS.promotions.flatrateVahaMoments.items.item3.title",
        description:
          "products.productS.promotions.flatrateVahaMoments.items.item3.description",
        priceBefore:
          "products.productS.promotions.flatrateVahaMoments.items.item3.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateVahaMoments.items.item3.priceAfter",
      },
      item4: {
        title:
          "products.productS.promotions.flatrateVahaMoments.items.item4.title",
        description:
          "products.productS.promotions.flatrateVahaMoments.items.item4.description",
        priceBefore:
          "products.productS.promotions.flatrateVahaMoments.items.item4.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateVahaMoments.items.item4.priceAfter",
      },
      item5: {
        title:
          "products.productS.promotions.flatrateVahaMoments.items.item5.title",
        description:
          "products.productS.promotions.flatrateVahaMoments.items.item5.description",
        priceBefore:
          "products.productS.promotions.flatrateVahaMoments.items.item5.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateVahaMoments.items.item5.priceAfter",
      },
      item6: {
        title:
          "products.productS.promotions.flatrateVahaMoments.items.item6.title",
        description:
          "products.productS.promotions.flatrateVahaMoments.items.item6.description",
        priceBefore:
          "products.productS.promotions.flatrateVahaMoments.items.item6.priceBefore",
        priceAfter:
          "products.productS.promotions.flatrateVahaMoments.items.item6.priceAfter",
      },
    },
  };
  
  export const vahaMomentsProductX = {
    mainPromoHeadline:
      "products.productX.promotions.vahaMoments.mainPromoHeadline",
    heading: {
      image: "products.productX.promotions.vahaMoments.heading.image",
      title: "products.productX.promotions.vahaMoments.heading.title",
    },
    pricesBeforeAfter: {
      priceBefore:
        "products.productX.promotions.vahaMoments.pricesBeforeAfter.priceBefore",
      priceAfter:
        "products.productX.promotions.vahaMoments.pricesBeforeAfter.priceAfter",
    },
    footer: "products.productX.promotions.vahaMoments.footer",
    total: {
      headline: "products.productX.promotions.vahaMoments.total.headline",
      priceBefore: "products.productX.promotions.vahaMoments.total.priceBefore",
      priceAfter: "products.productX.promotions.vahaMoments.total.priceAfter",
    },
    discount: {
      heading: "products.productX.promotions.vahaMoments.discount.heading",
      title: "products.productX.promotions.vahaMoments.discount.title",
      amount: "products.productX.promotions.vahaMoments.discount.amount",
      code: {
        description:
          "products.productX.promotions.vahaMoments.discount.code.description",
        promoCode:
          "products.productX.promotions.vahaMoments.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title: "products.productX.promotions.vahaMoments.items.item1.title",
        description:
          "products.productX.promotions.vahaMoments.items.item1.description",
        priceBefore:
          "products.productX.promotions.vahaMoments.items.item1.priceBefore",
        priceAfter:
          "products.productX.promotions.vahaMoments.items.item1.priceAfter",
      },
      item2: {
        title: "products.productX.promotions.vahaMoments.items.item2.title",
        description:
          "products.productX.promotions.vahaMoments.items.item2.description",
        priceBefore:
          "products.productX.promotions.vahaMoments.items.item2.priceBefore",
        priceAfter: "products.productX.promotions.vahaMoments.items.item2.priceAfter",
      },
      item3: {
        title: "products.productX.promotions.vahaMoments.items.item3.title",
        description:
          "products.productX.promotions.vahaMoments.items.item3.description",
        priceBefore:
          "products.productX.promotions.vahaMoments.items.item3.priceBefore",
        priceAfter:
          "products.productX.promotions.vahaMoments.items.item3.priceAfter",
      },
      item4: {
        title: "products.productX.promotions.vahaMoments.items.item4.title",
        description:
          "products.productX.promotions.vahaMoments.items.item4.description",
        priceBefore:
          "products.productX.promotions.vahaMoments.items.item4.priceBefore",
        priceAfter:
          "products.productX.promotions.vahaMoments.items.item4.priceAfter",
      },
      item5: {
        title: "products.productX.promotions.vahaMoments.items.item5.title",
        description:
          "products.productX.promotions.vahaMoments.items.item5.description",
        priceBefore:
          "products.productX.promotions.vahaMoments.items.item5.priceBefore",
        priceAfter:
          "products.productX.promotions.vahaMoments.items.item5.priceAfter",
      },
    },
  };
  
  export const flatrateVahaMomentsProductX = {
    mainPromoHeadline:
      "products.productX.promotions.flatrateVahaMoments.mainPromoHeadline",
    heading: {
      image: "products.productX.promotions.flatrateVahaMoments.heading.image",
      title: "products.productX.promotions.flatrateVahaMoments.heading.title",
    },
    footer: "products.productX.promotions.flatrateVahaMoments.footer",
    total: {
      headline:
        "products.productX.promotions.flatrateVahaMoments.total.headline",
      priceBefore:
        "products.productX.promotions.flatrateVahaMoments.total.priceBefore",
      priceAfter:
        "products.productX.promotions.flatrateVahaMoments.total.priceAfter",
    },
    discount: {
      heading: "products.productX.promotions.vahaMoments.discount.heading",
      title: "products.productX.promotions.flatrateVahaMoments.discount.title",
      amount: "products.productX.promotions.flatrateVahaMoments.discount.amount",
      code: {
        description:
          "products.productX.promotions.flatrateVahaMoments.discount.code.description",
        promoCode:
          "products.productX.promotions.flatrateVahaMoments.discount.code.promoCode",
      },
    },
    items: {
      item1: {
        title:
          "products.productX.promotions.flatrateVahaMoments.items.item1.title",
        description:
          "products.productX.promotions.flatrateVahaMoments.items.item1.description",
        priceBefore:
          "products.productX.promotions.flatrateVahaMoments.items.item1.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateVahaMoments.items.item1.priceAfter",
      },
      item2: {
        title:
          "products.productX.promotions.flatrateVahaMoments.items.item2.title",
        description:
          "products.productX.promotions.flatrateVahaMoments.items.item2.description",
        priceBefore:
          "products.productX.promotions.flatrateVahaMoments.items.item2.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateVahaMoments.items.item2.priceAfter",
      },
      item3: {
        title:
          "products.productX.promotions.flatrateVahaMoments.items.item3.title",
        description:
          "products.productX.promotions.flatrateVahaMoments.items.item3.description",
        priceBefore:
          "products.productX.promotions.flatrateVahaMoments.items.item3.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateVahaMoments.items.item3.priceAfter",
      },
      item4: {
        title:
          "products.productX.promotions.flatrateVahaMoments.items.item4.title",
        description:
          "products.productX.promotions.flatrateVahaMoments.items.item4.description",
        priceBefore:
          "products.productX.promotions.flatrateVahaMoments.items.item4.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateVahaMoments.items.item4.priceAfter",
      },
      item5: {
        title:
          "products.productX.promotions.flatrateVahaMoments.items.item5.title",
        description:
          "products.productX.promotions.flatrateVahaMoments.items.item5.description",
        priceBefore:
          "products.productX.promotions.flatrateVahaMoments.items.item5.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateVahaMoments.items.item5.priceAfter",
      },
      item6: {
        title:
          "products.productX.promotions.flatrateVahaMoments.items.item6.title",
        description:
          "products.productX.promotions.flatrateVahaMoments.items.item6.description",
        priceBefore:
          "products.productX.promotions.flatrateVahaMoments.items.item6.priceBefore",
        priceAfter:
          "products.productX.promotions.flatrateVahaMoments.items.item6.priceAfter",
      },
    },
  };
  